import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

const getActiveMenuCategories = createAsyncThunk('basicinfo/getActiveMenuCategories', async () => {
  return await BasicInfoHttpGetService({
    url: `${_apiPathManagerConfig?.BasicInfo.MenuCategory.GetActiveMenuCategories}`,
  });
});

export default getActiveMenuCategories;
